import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';

const BUTTON_SIZES = {
  small: '1.875rem',
  medium: '2.5rem',
  large: '3.125rem',
};

const getCursor = ({ isDisabled, isLoading }) => {
  let cursor = isLoading ? 'cursor-wait' : 'cursor-pointer';
  if (isDisabled) cursor = 'cursor-default pointer-events-none';
  return cursor;
};

const getColors = ({
  color = COLORS.WHITE,
  colorBg = COLORS.BLUE,
  colorBorder = COLORS.BLUE,
  isDisabled,
  isLoading,
}) => {
  if (isDisabled) return 'bg-gray-light border-gray-light text-white';

  return classnames(`bg-${colorBg} border-${colorBorder} text-${color}`, {
    [`focus:bg-${colorBg}-active focus:border-${colorBorder}-active hover:bg-${colorBg}-active hover:border-${colorBorder}-active focus:text-${color}-active hover:text-${color}-active`]: !isLoading,
  });
};

export const themes = {
  default: props => ({
    thButton: classnames(
      'reset-button inline-flex flex-col items-stretch overflow-hidden text-base transition-colors',
      getColors(props),
      getCursor(props),
      {
        'border-1 border-solid': props.colorBorder,
        'rounded-tiny': !props.isFlat,
      },
    ),
    thSize: {
      minHeight: BUTTON_SIZES[props.size || 'medium'],
      minWidth: props.minWidth || '10rem',
    },
    thContent: 'flex justify-center items-center font-bold px-4 py-1 h-full',
    thChildren: 'm-1 text-center',
    thIcon: 'flex-shrink-0 m-1',
    thSpinner: 'flex-shrink-0 leading-none m-1',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
  link: props => ({
    thButton: classnames('p-2 bg-transparent border-none', getCursor(props)),
    thSize: {
      minHeight: BUTTON_SIZES[props.size || 'medium'],
      minWidth: props.minWidth || '10rem',
    },
    thIcon: 'flex-shrink-0 m-1',
    thSpinner: 'flex-shrink-0 leading-none m-1',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
  anchor: () => ({
    thButton: classnames(
      'border-none',
      'bg-transparent',
      'underline',
      'bg-none',
      'cursor-pointer',
      'text-gray',
      'mt-4',
      'sm:mt-0',
      'sm:mr-4',
    ),
    thSpinner: 'flex-shrink-0 leading-none m-1',
  }),
  formSubmit: props => ({
    thButton: classnames(
      'reset-button inline-flex flex-col items-stretch overflow-hidden text-xl transition-colors uppercase',
      getColors(props),
      getCursor(props),
      {
        'border-1 border-solid': props.colorBorder,
        'rounded-tiny': !props.isFlat,
      },
    ),
    thSize: { minHeight: BUTTON_SIZES[props.size || 'medium'], minWidth: '10rem' },
    thContent: 'flex justify-center items-center font-bold px-8',
    thChildren: 'm-2 text-center',
    thIcon: 'flex-shrink-0 m-2',
    thSpinner: 'flex-shrink-0 leading-none m-2',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
  square: props => ({
    thButton: classnames(
      'reset-button inline-flex flex-col items-stretch overflow-hidden text-base transition-colors uppercase',
      getColors(props),
      getCursor(props),
      {
        'border-1 border-solid': props.colorBorder,
        'rounded-tiny': !props.isFlat,
      },
    ),
    thSize: { minHeight: '6rem', width: '8rem' },
    thContent: 'flex justify-center items-center font-bold',
    thChildren: 'm-1 text-center',
    thIcon: 'flex-shrink-0 m-1',
    thSpinner: 'flex-shrink-0 leading-none m-1',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
  selectPriceSquareButton: props => ({
    thButton: classnames(
      'reset-button inline-flex flex-col items-stretch overflow-hidden text-base transition-colors',
      getColors(props),
      getCursor(props),
      {
        'border-1 border-solid': props.colorBorder,
        'rounded-tiny': !props.isFlat,
      },
    ),
    thSize: {
      minHeight: BUTTON_SIZES[props.size || 'medium'],
      minWidth: props.minWidth || '10rem',
    },
    thContent: 'flex items-center font-bold py-1',
    thChildren: 'm-1 px-1 w-full',
    thIcon: 'flex-shrink-0 m-1',
    thSpinner: 'flex-shrink-0 leading-none m-1',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
  selectAndContinue: props => ({
    thButton: classnames(
      'reset-button inline-flex flex-col items-stretch overflow-hidden text-base transition-colors',
      getColors(props),
      getCursor(props),
      {
        'border-1 border-solid': props.colorBorder,
        'rounded-tiny': !props.isFlat,
      },
    ),
    thSize: {
      minHeight: BUTTON_SIZES[props.size || 'medium'],
      minWidth: props.minWidth || '10rem',
    },
    thContent: 'flex justify-center items-center font-bold px-2 py-1',
    thChildren: 'm-1 text-center',
    thIcon: 'flex-shrink-0 m-1',
    thSpinner: 'flex-shrink-0 leading-none m-1',
    thSlot: 'bg-overlay-black-30 font-bold flex items-center px-4 self-stretch text-white',
  }),
};
